import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import "./JobDashboardApplicationsBlock.scss";
import useTranslationJobDashboard from "../useTranslationJobDashboard.js";
import JobDashboardApplicationsCount from "./JobDashboardApplicationsCount.js";
import useQueryStatusGroupAndCount from "../search/useQueryStatusGroupAndCount.js";
import useQueryDateByValueSearchCount from "../search/useQueryDateGroupAndCount.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import RouterUtils from "../../../utils/RouterUtils.js";
import * as ROUTES from "../../../constants/routes.js";
import ActionDiv from "../../common/widgets/ActionDiv.js";
import NewCandidatesByJobCount from "../../jobs/search/NewApplicationByJobCount.js";
import PageSubtitle from "../../common/widgets/PageSubtitle.js";
import ApplicationStatusEnum from "../../candidates/ApplicationStatusEnum.js";
import useReferrer from "../../infra-no-ui/navigation/useReferrer.js";

function JobDashboardApplicationsBlock(props) {
  const { job } = props;

  const { t, loading: tLoading } = useTranslationJobDashboard();
  useShowLoader(tLoading, "JobDashboardApplicationsBlock");

  const {
    data: counts,
    loading,
    errors,
  } = useQueryStatusGroupAndCount(job._id);

  const { loading: candidatesByDateLoading, errors: candidatesByDateErrors } =
    useQueryDateByValueSearchCount(job._id);

  const blockTitle = t("job-dashboard:job_dashboard_applications_list_label");
  const statusStackLabel = t(
    "job-dashboard:job_dashboard_applications_status_stack_label"
  );
  const statusShortlistLabel = t(
    "job-dashboard:job_dashboard_applications_status_shortlist_label"
  );
  const statusHiredLabel = t(
    "job-dashboard:job_dashboard_applications_status_hired_label"
  );

  const getCountForStatus = (status) => {
    const statusItem = counts.find((item) => item.status === status);
    return statusItem ? statusItem["count"] : 0;
  };

  const {redirectTo} = useReferrer();

  function onClickStatus(event, jobId, status) {
    event.preventDefault();
    redirectTo({
      pathname: RouterUtils.injectParamsInRoute(
        ROUTES.EMPLOYER_JOB_CANDIDATES,
        {
          jobId,
        }
      ),
      state: { status },
    });
  }

  return (
    <>
      <WaitForData
        loading={loading || candidatesByDateLoading}
        errors={errors || candidatesByDateErrors}
        onLoaded={() => (
          <div className="JobDashboardApplicationsBlock">
            <PageSubtitle colTitle={blockTitle} />
            <Row className="jobCountRow">
              <Col className="jobCountCol">
                <NewCandidatesByJobCount jobId={job._id} />
              </Col>
            </Row>
            <Row className="actionLinkContainer">
              <Col>
                <Row>
                  <Col>
                    <ActionDiv
                      onClick={(event) =>
                        onClickStatus(event, job._id, ApplicationStatusEnum.STACK)
                      }
                      className={"ApplicationCountAction"}
                    >
                      <JobDashboardApplicationsCount
                        label={statusStackLabel}
                        count={getCountForStatus(ApplicationStatusEnum.STACK)}
                      />
                    </ActionDiv>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ActionDiv
                      onClick={(event) =>
                        onClickStatus(event, job._id, ApplicationStatusEnum.SHORTLIST)
                      }
                      className={"ApplicationCountAction"}
                    >
                      <JobDashboardApplicationsCount
                        label={statusShortlistLabel}
                        count={getCountForStatus(ApplicationStatusEnum.SHORTLIST)}
                      />
                    </ActionDiv>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ActionDiv
                      onClick={(event) =>
                        onClickStatus(event, job._id, ApplicationStatusEnum.HIRED)
                      }
                      className={"ApplicationCountAction"}
                    >
                      <JobDashboardApplicationsCount
                        label={statusHiredLabel}
                        count={getCountForStatus(ApplicationStatusEnum.HIRED)}
                      />
                    </ActionDiv>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
      />
    </>
  );
}

export default JobDashboardApplicationsBlock;
